<template>
  <div class="box">
    <my-title size="6">Bundels</my-title>

    <table class="table is-striped">
      <tbody>
        <tr v-for="bundle in myBundles" :key="bundle.id">
          <td>{{ bundle.name }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import MyTitle from '@/components/modules/Title'

export default {
  props: [
    'myBundles'
  ],
  components: {
    MyTitle
  }
}
</script>
